export const infoCard = {
	seeDatails: "See details",
};
